import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
import styles from './styles'
import UserType from 'src/model/user-types'
const QuestionCountSelector = ({
  classes,
  questionCount,
  onQuestionCountChange,
  resourceType,
  mode = 'quiz',
}) => {
  const handleQuestionCountChange = newValue => {
    if (newValue >= 1 && newValue <= 15) {
      onQuestionCountChange(newValue)
    }
  }

  const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]
  const isUserAllowed =
    resourceType === 'pdf' &&
    (userControl == 'Basic' ||
      userControl == 'AppSumo (Tier 2)' ||
      userControl == 'AppSumo (Tier 1)' ||
      userControl == 'AppSumo (Tier 2A)' ||
      userControl == 'AppSumo (Tier 1A)')

  return (
    <div
      className={classes.numberInputContainer}
      style={{
        display: isUserAllowed ? 'none' : 'flex',
      }}
    >
      <Typography className={classes.numberInputLabel}>
        {mode === 'page' ? 'Number of pages' : 'Number of quiz questions'}
      </Typography>
      <CoreTextField
        value={questionCount}
        className={classes.numberInput}
        InputProps={{
          startAdornment: (
            <div
              className={classes.inputButton}
              onClick={() => handleQuestionCountChange(questionCount - 1)}
            >
              -
            </div>
          ),
          endAdornment: (
            <div
              className={classes.inputButton}
              onClick={() => handleQuestionCountChange(questionCount + 1)}
            >
              +
            </div>
          ),
          readOnly: true,
        }}
        inputProps={{
          style: { textAlign: 'center' },
        }}
      />
    </div>
  )
}

export default withStyles(styles)(QuestionCountSelector)
